import styled from 'styled-components'

export const StSlideWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.UI.Spacing.Space10}px;
`
export const StSlideGraphic = styled.img`
  padding: ${({ theme }) => theme.UI.Spacing.Space4}px;
  display: flex;
  justify-content: center;
  flex-grow: 1;
  align-items: center;
`
